<template>
  <section id="view-by-map">
    <google-map
    ref="googleMaps"
    height="75vh"
    :locations="locations"
    :fitBounds="true"
    @onClickMarker="onClickMarker"
    />

    <show-multiple-screenings-modal
      v-if="selectedScreeningGroup !== null"
      :screeningGroup="selectedScreeningGroup"
      @modalClosed="selectedScreeningGroup = null"
      @updateScreening="onUpdateScreening">
    </show-multiple-screenings-modal>

  </section>
</template>

<script>
import { groupByFacility } from './utils/screenings.js'
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin'
import GoogleMap from '@/components/maps/google-maps/GoogleMap'
import ShowMultipleScreeningsModal from './ShowMultipleScreeningsModal'

export default {
  props: {
    data: {
      type: Array,
      required: false
    }
  },
  components: {
    GoogleMap,
    ShowMultipleScreeningsModal
  },
  mixins: [
    IsFromEvolluMixin
  ],
  data: function () {
    return {
      dataset: [],
      locations: [],
      facilitiesWithoutAddress: [],
      selectedScreeningGroup: null
    }
  },
  methods: {
    createLocation: function (id, label, lat, lng) {
      let location = { id, position: { lat, lng } }

      if (label !== '' && label !== 0) location.label = label

      return location
    },
    selectScreening: function (screening) {
      if (screening.facility) {
        let datasetRecord = this.dataset.find(element => element.facility.id === screening.facility.id)
        if (datasetRecord && datasetRecord.facility.address && datasetRecord.facility.address.latitude && datasetRecord.facility.address.latitude) {
          this.$refs.googleMaps.updateCenter({ lat: datasetRecord.facility.address.latitude, lng: datasetRecord.facility.address.longitude })
          this.$refs.googleMaps.updateZoom(11)
          return
        }
      }
      this.showToast(this.$t('agenda.screenings.could_not_find_map_location'), this.$store.state.errorToastOptions)
    },
    onClickMarker: function (marker) {
      this.selectedScreeningGroup = this.dataset[marker.id] || null
    },
    onUpdateScreening: function (screening) {
      this.selectedScreeningGroup = null
      this.$emit('updateScreening', screening)
    }
  },
  watch: {
    data: {
      handler: function (data) {
        let locations = []
        let facilitiesWithoutAddress = []
        if (data.length > 0) {
          this.dataset = groupByFacility(data)
          this.dataset.forEach((group, index) => {
            if (group.facility) {
              if (group.facility.address && group.facility.address.latitude && group.facility.address.longitude) {
                const location = this.createLocation(index, group.screenings.length, group.facility.address.latitude, group.facility.address.longitude)
                locations.push(location)
              } else {
                facilitiesWithoutAddress.push(group.facility)
              }
            }
          })
        }

        this.locations = locations
        this.facilitiesWithoutAddress = facilitiesWithoutAddress

        if (this.facilitiesWithoutAddress.length > 0 && this.isFromEvollu) {
          this.showToast(this.$t('agenda.screenings.facilities_without_address', { count: this.facilitiesWithoutAddress.length }), this.$store.state.errorToastOptions)
        }
      },
      immediate: true
    }
  }
}
</script>
